import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
  background: #ffffff;
}

:host ::ng-deep .wb-console-shell[data-console=management] {
  --wb-ink: #10241a;
  --wb-muted: #65766d;
  --wb-line: #dce7e0;
  --wb-line-strong: #c7d8ce;
  --wb-canvas: #f3f7f4;
  --wb-surface: #ffffff;
  --wb-soft: #edf6f0;
  --wb-brand: #197443;
  --wb-brand-strong: #0d5b34;
  --wb-brand-dark: #0a3322;
  --wb-focus: rgba(34, 139, 78, 0.17);
  color: var(--wb-ink);
  background: var(--wb-canvas);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-frame {
  width: 16rem;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-surface {
  border-color: #dfe8e2 !important;
  background: radial-gradient(circle at 12% 6%, rgba(123, 190, 86, 0.12), transparent 12rem), linear-gradient(180deg, #ffffff 0%, #fbfdfc 56%, #f5faf7 100%) !important;
  box-shadow: 12px 0 40px rgba(22, 58, 38, 0.035);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-console-stage {
  background: var(--wb-canvas);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-console-header {
  height: 4rem !important;
  border-color: rgba(202, 216, 208, 0.82) !important;
  background: rgba(255, 255, 255, 0.88) !important;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.82), 0 10px 30px rgba(22, 58, 38, 0.025);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-console-topnav > a {
  overflow: hidden;
  transition: color 240ms ease, background-color 240ms ease, border-color 240ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-console-topnav > a::after {
  position: absolute;
  right: 1.25rem;
  bottom: -2px;
  left: 1.25rem;
  height: 2px;
  border-radius: 999px 999px 0 0;
  background: var(--wb-brand);
  content: "";
  opacity: 0;
  transform: scaleX(0.45);
  transition: opacity 220ms ease, transform 300ms cubic-bezier(0.2, 0.8, 0.2, 1);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-console-topnav > a[class*=border-emerald]::after {
  opacity: 1;
  transform: scaleX(1);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-route-stage {
  scroll-behavior: smooth;
  background: radial-gradient(circle at 76% -12%, rgba(133, 194, 100, 0.11), transparent 33rem), linear-gradient(180deg, #f7faf8 0%, var(--wb-canvas) 100%) !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-route-stage > router-outlet + * {
  display: block;
  min-height: 100%;
  animation: wb-route-enter 460ms cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-fill-mode: backwards;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-route-stage > router-outlet + *:has(.ipm-office-registration-modal) {
  animation: none !important;
  transform: none !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page:has(.ipm-office-registration-modal) {
  isolation: auto;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-route-stage:has(.ipm-office-registration-modal) {
  overflow: hidden !important;
  scroll-behavior: auto;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-brand {
  padding-top: 1.25rem;
  padding-bottom: 1.15rem;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-brand img {
  height: 2.45rem;
  filter: drop-shadow(0 8px 14px rgba(43, 105, 51, 0.09));
  transition: transform 300ms cubic-bezier(0.22, 1, 0.36, 1), filter 300ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-brand a:hover img {
  filter: drop-shadow(0 10px 18px rgba(43, 105, 51, 0.16));
  transform: translateY(-1px) scale(1.015);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-account-card {
  overflow: hidden;
  border-color: var(--wb-line) !important;
  border-radius: 0.9rem !important;
  background: rgba(255, 255, 255, 0.82) !important;
  box-shadow: 0 8px 24px rgba(21, 54, 36, 0.045);
  transition: border-color 240ms ease, box-shadow 240ms ease, transform 240ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-account-card:hover {
  border-color: var(--wb-line-strong) !important;
  box-shadow: 0 12px 28px rgba(21, 54, 36, 0.075);
  transform: translateY(-1px);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-nav {
  scrollbar-color: #cbd9d0 transparent;
  scrollbar-width: thin;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-group--management > .wb-sidebar-group-title {
  position: relative;
  margin: 0 0.15rem 0.7rem;
  padding: 0.7rem 0.75rem 0.7rem 1rem;
  overflow: hidden;
  border: 1px solid rgba(5, 150, 105, 0.16);
  border-radius: 0.75rem;
  color: var(--wb-brand) !important;
  background: linear-gradient(135deg, rgba(236, 253, 245, 0.96), rgba(240, 253, 250, 0.72));
  box-shadow: 0 6px 18px rgba(5, 150, 105, 0.06);
  font-size: 0.92rem !important;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.01em;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-group--management > .wb-sidebar-group-title::before {
  position: absolute;
  top: 0.55rem;
  bottom: 0.55rem;
  left: 0.45rem;
  width: 0.2rem;
  border-radius: 999px;
  background: var(--wb-brand);
  content: "";
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-link {
  position: relative;
  min-height: 2.4rem;
  border-radius: 0.65rem !important;
  will-change: transform;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-link:hover {
  transform: translateX(2px);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-link[class*=bg-emerald-700] {
  background: linear-gradient(135deg, #0e7850 0%, #07815d 100%) !important;
  box-shadow: 0 8px 18px rgba(12, 108, 72, 0.2);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-link[class*=bg-emerald-700]::before {
  position: absolute;
  top: 50%;
  left: -0.5rem;
  width: 3px;
  height: 1.15rem;
  border-radius: 999px;
  background: #71be4b;
  content: "";
  transform: translateY(-50%);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-console-switcher > a {
  border-color: var(--wb-line) !important;
  border-radius: 0.8rem !important;
  background: rgba(255, 255, 255, 0.72) !important;
  transition: border-color 240ms ease, box-shadow 240ms ease, transform 240ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-console-switcher > a:hover {
  border-color: #b9d6c5 !important;
  box-shadow: 0 10px 24px rgba(21, 54, 36, 0.07);
  transform: translateY(-2px);
}
:host ::ng-deep .wb-mobile-nav {
  visibility: hidden;
  pointer-events: none;
  transition: visibility 0s linear 320ms;
}
:host ::ng-deep .wb-mobile-nav.is-open {
  visibility: visible;
  pointer-events: auto;
  transition-delay: 0s;
}
:host ::ng-deep .wb-mobile-backdrop {
  opacity: 0;
  backdrop-filter: blur(0);
  transition: opacity 260ms ease, backdrop-filter 320ms ease;
}
:host ::ng-deep .wb-mobile-nav.is-open .wb-mobile-backdrop {
  opacity: 1;
  backdrop-filter: blur(5px);
}
:host ::ng-deep .wb-mobile-drawer {
  opacity: 0.72;
  transform: translate3d(-102%, 0, 0);
  transition: opacity 260ms ease, transform 360ms cubic-bezier(0.22, 1, 0.36, 1);
}
:host ::ng-deep .wb-mobile-nav.is-open .wb-mobile-drawer {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-menu-trigger {
  border-color: var(--wb-line) !important;
  background: rgba(255, 255, 255, 0.85);
  transition: color 220ms ease, border-color 220ms ease, background-color 220ms ease, transform 220ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=management] .wb-menu-trigger:hover {
  border-color: #aed0bc !important;
  color: var(--wb-brand);
  transform: scale(1.03);
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page {
  position: relative;
  isolation: isolate;
  min-height: 100%;
  padding: clamp(1rem, 2vw, 1.8rem) !important;
  color: var(--wb-ink);
  background: radial-gradient(circle at 3% 0%, rgba(118, 190, 82, 0.09), transparent 23rem), transparent !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page::before {
  position: absolute;
  z-index: -1;
  top: 0;
  right: 5%;
  width: 18rem;
  height: 12rem;
  border-radius: 999px;
  background: rgba(222, 240, 228, 0.35);
  content: "";
  filter: blur(60px);
  pointer-events: none;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-container {
  max-width: 80rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page--offices > :not(.ipm-office-registration-backdrop):not(.ipm-office-registration-modal),
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page--office-detail > * {
  width: 100%;
  max-width: 80rem;
  margin-right: auto;
  margin-left: auto;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-hero {
  position: relative;
  border: 1px solid rgba(202, 218, 208, 0.92) !important;
  border-radius: 1.15rem !important;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(247, 251, 248, 0.96)) !important;
  box-shadow: 0 16px 44px rgba(20, 52, 35, 0.07), inset 0 1px 0 #fff !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-hero::before {
  position: absolute;
  top: 0;
  left: 2rem;
  width: 5rem;
  height: 3px;
  border-radius: 0 0 999px 999px;
  background: linear-gradient(90deg, #6fb945, #128352);
  content: "";
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-hero > div:first-child {
  min-height: 7.2rem;
  padding: 1.65rem 1.8rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-hero h1 {
  color: var(--wb-ink) !important;
  font-size: clamp(1.45rem, 2vw, 1.8rem) !important;
  font-weight: 800 !important;
  letter-spacing: -0.035em !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-hero > div:first-child > div:first-child > p:first-child {
  color: var(--wb-brand) !important;
  letter-spacing: 0.17em !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-hero--legacy > div:first-child > div:first-child > p:last-child {
  color: var(--wb-muted) !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-hero--legacy > div:first-child > div:last-child span {
  border-color: #c9dfd0 !important;
  background: #eff8f2 !important;
  color: var(--wb-brand-strong) !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-segmented-nav {
  position: relative;
  gap: 0.35rem !important;
  padding: 0.55rem 0.75rem !important;
  border-color: rgba(220, 231, 224, 0.86) !important;
  background: rgba(242, 247, 244, 0.78) !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-segmented-nav > a,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-segmented-nav > button {
  position: relative;
  min-height: 2.35rem;
  border-radius: 0.7rem !important;
  white-space: nowrap;
  transition: color 220ms ease, background-color 220ms ease, border-color 220ms ease, box-shadow 240ms ease, transform 220ms ease !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-segmented-nav > a:hover,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-segmented-nav > button:hover {
  transform: translateY(-1px);
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-segmented-nav > [class*=bg-emerald-700] {
  background: linear-gradient(135deg, #116d45, #07835d) !important;
  box-shadow: 0 7px 16px rgba(13, 108, 72, 0.18) !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-view {
  transform-origin: 50% 0;
  animation: wb-view-enter 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-view > .grid:first-child > section {
  animation: wb-card-enter 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-view > .grid:first-child > section:nth-child(2) {
  animation-delay: 55ms;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-view > .grid:first-child > section:nth-child(3) {
  animation-delay: 110ms;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-view > .grid:first-child > section:nth-child(4) {
  animation-delay: 165ms;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page section:not(.ipm-hero):not(.ipm-modal):not(.ipm-detail-section) {
  border-color: var(--wb-line) !important;
  border-radius: 1rem !important;
  box-shadow: 0 10px 30px rgba(18, 50, 33, 0.045), inset 0 1px 0 rgba(255, 255, 255, 0.72) !important;
  transition: border-color 250ms ease, box-shadow 250ms ease, transform 250ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-view > .grid > section:hover,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-view > section:first-child:hover {
  border-color: var(--wb-line-strong) !important;
  box-shadow: 0 16px 36px rgba(18, 50, 33, 0.075) !important;
  transform: translateY(-2px);
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page article,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page tbody tr,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page .divide-y > button {
  transition: background-color 200ms ease, box-shadow 220ms ease, transform 220ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page article:hover,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page tbody tr:hover,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page .divide-y > button:hover {
  background-color: rgba(239, 248, 242, 0.62) !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page .divide-y > button:hover {
  box-shadow: inset 3px 0 0 #49a36b;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page table {
  font-size: 0.75rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page thead {
  color: #617169 !important;
  background: #f5f8f6 !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page th {
  padding-top: 0.78rem !important;
  padding-bottom: 0.78rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.01em;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page td {
  padding-top: 0.82rem !important;
  padding-bottom: 0.82rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page input:not([type=checkbox]):not([type=radio]),
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page select,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page textarea {
  border-color: #d7e2dc !important;
  border-radius: 0.68rem !important;
  background-color: #fff !important;
  box-shadow: 0 1px 2px rgba(18, 50, 33, 0.025);
  transition: border-color 200ms ease, background-color 200ms ease, box-shadow 220ms ease, transform 220ms ease !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page input:not([type=checkbox]):not([type=radio]):hover,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page select:hover,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page textarea:hover {
  border-color: #b9d2c3 !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page input:not([type=checkbox]):not([type=radio]):focus,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page select:focus,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page textarea:focus {
  border-color: #4a9d6b !important;
  box-shadow: 0 0 0 4px var(--wb-focus), 0 8px 20px rgba(18, 82, 48, 0.06) !important;
  outline: none !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page input::placeholder,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page textarea::placeholder {
  color: #9ba9a1;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-select svg {
  color: #789086 !important;
  transform: translateY(-50%) rotate(0deg);
  transition: color 220ms ease, transform 300ms cubic-bezier(0.22, 1, 0.36, 1);
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-select:focus-within svg {
  color: var(--wb-brand) !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-select:has(select:open) svg {
  transform: translateY(-50%) rotate(180deg);
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page button,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page a {
  transition: color 220ms ease, background-color 220ms ease, border-color 220ms ease, box-shadow 240ms ease, opacity 220ms ease, transform 220ms ease !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page button:not(:disabled):active,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page a:active {
  transform: translateY(1px) scale(0.99);
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page button:focus-visible,
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page a:focus-visible,
:host ::ng-deep .wb-console-shell[data-console=management] .wb-sidebar-link:focus-visible,
:host ::ng-deep .wb-console-shell[data-console=management] .wb-menu-trigger:focus-visible {
  outline: 3px solid rgba(43, 145, 81, 0.22);
  outline-offset: 2px;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page input[type=checkbox]:not(.ipm-switch-control) {
  width: 1.05rem;
  height: 1.05rem;
  border-color: #bdcec4;
  accent-color: var(--wb-brand);
  cursor: pointer;
  transition: border-color 200ms ease, box-shadow 200ms ease, transform 200ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page input[type=checkbox]:not(.ipm-switch-control):checked {
  transform: scale(1.06);
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-page input[type=checkbox]:not(.ipm-switch-control):focus-visible {
  box-shadow: 0 0 0 4px var(--wb-focus);
  outline: none;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-switch {
  cursor: pointer;
  border: 1px solid transparent;
  transition: color 220ms ease, background-color 220ms ease, border-color 220ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-switch:has(.ipm-switch-control:checked) {
  border-color: #c3dfcc;
  color: var(--wb-brand-strong) !important;
  background: #eff8f2 !important;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-switch-control {
  position: relative;
  width: 2.35rem;
  height: 1.35rem;
  flex: 0 0 auto;
  appearance: none;
  border: 0;
  border-radius: 999px;
  background: #cbd5cf;
  cursor: pointer;
  transition: background-color 240ms ease, box-shadow 240ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-switch-control::before {
  position: absolute;
  top: 0.2rem;
  left: 0.2rem;
  width: 0.95rem;
  height: 0.95rem;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 6px rgba(18, 50, 33, 0.2);
  content: "";
  transition: transform 280ms cubic-bezier(0.22, 1, 0.36, 1);
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-switch-control:checked {
  background: linear-gradient(135deg, #1e8b50, #0f7650);
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-switch-control:checked::before {
  transform: translateX(1rem);
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-switch-control:focus-visible {
  box-shadow: 0 0 0 4px var(--wb-focus);
  outline: none;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-choice {
  width: 100%;
  padding: 0.7rem 0.8rem;
  border: 1px solid var(--wb-line);
  border-radius: 0.75rem;
  background: #fafcfb;
  cursor: pointer;
  transition: color 220ms ease, border-color 220ms ease, background-color 220ms ease, box-shadow 220ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-choice:has(input:checked) {
  border-color: #abd2ba;
  color: var(--wb-brand-strong) !important;
  background: #eff8f2;
  box-shadow: 0 5px 16px rgba(20, 96, 55, 0.06);
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-collapse {
  transform-origin: 50% 0;
  animation: wb-collapse-enter 300ms cubic-bezier(0.22, 1, 0.36, 1) both;
}
:host ::ng-deep .ipm-modal-backdrop {
  animation: wb-backdrop-enter 220ms ease both;
  backdrop-filter: blur(6px);
}
:host ::ng-deep .ipm-modal {
  border: 1px solid rgba(220, 231, 224, 0.92);
  border-radius: 1.1rem !important;
  box-shadow: 0 30px 80px rgba(7, 29, 18, 0.22) !important;
  animation: wb-modal-enter 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}
:host ::ng-deep .wb-console-shell[data-console=management] .ipm-empty-page {
  margin: 2rem;
  border: 1px dashed #c9d8cf;
  border-radius: 1rem;
  background: #fff;
  text-align: center;
}
@media (min-width: 1280px) {
  :host ::ng-deep .wb-console-shell[data-console=management] .ipm-page--consultations .ipm-view aside,
  :host ::ng-deep .wb-console-shell[data-console=management] .ipm-page--qna .ipm-view aside,
  :host ::ng-deep .wb-console-shell[data-console=management] .ipm-page--office-detail .ipm-view > aside {
    position: sticky;
    top: 1rem;
    align-self: start;
    max-height: calc(100vh - 6rem);
    overflow-y: auto;
    scrollbar-color: #cbd9d0 transparent;
    scrollbar-width: thin;
  }
}
@media (max-width: 767px) {
  :host ::ng-deep .wb-console-shell[data-console=management] .ipm-page {
    padding: 0.75rem !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=management] .ipm-hero > div:first-child {
    min-height: auto;
    padding: 1.25rem !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=management] .ipm-hero::before {
    left: 1.25rem;
  }
  :host ::ng-deep .wb-console-shell[data-console=management] .ipm-segmented-nav {
    overflow-x: auto;
    scrollbar-width: none;
  }
  :host ::ng-deep .wb-console-shell[data-console=management] .ipm-segmented-nav::-webkit-scrollbar {
    display: none;
  }
  :host ::ng-deep .wb-console-shell[data-console=management] .ipm-page .ipm-select {
    max-width: none;
  }
}
@keyframes wb-route-enter {
  from {
    opacity: 0;
    transform: translate3d(0, 12px, 0) scale(0.995);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
@keyframes wb-view-enter {
  from {
    opacity: 0;
    transform: translate3d(0, 9px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes wb-card-enter {
  from {
    opacity: 0;
    transform: translate3d(0, 8px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes wb-collapse-enter {
  from {
    opacity: 0;
    transform: translate3d(0, -5px, 0) scaleY(0.97);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scaleY(1);
  }
}
@keyframes wb-backdrop-enter {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes wb-modal-enter {
  from {
    opacity: 0;
    transform: translate3d(0, 14px, 0) scale(0.975);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  :host ::ng-deep .wb-console-shell[data-console=management] *,
  :host ::ng-deep .wb-console-shell[data-console=management] *::before,
  :host ::ng-deep .wb-console-shell[data-console=management] *::after,
  :host ::ng-deep .ipm-modal-backdrop,
  :host ::ng-deep .ipm-modal {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
:host ::ng-deep .wb-console-shell[data-console=transaction] {
  --wt-ink: #10252b;
  --wt-muted: #647780;
  --wt-line: #d6e5e8;
  --wt-line-strong: #bcd6da;
  --wt-canvas: #f2f7f8;
  --wt-surface: #ffffff;
  --wt-soft: #edf7f8;
  --wt-brand: #08798a;
  --wt-brand-strong: #056477;
  --wt-brand-dark: #0b3440;
  --wt-accent: #4f6fc4;
  --wt-focus: rgba(8, 121, 138, 0.17);
  color: var(--wt-ink);
  background: var(--wt-canvas);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-brand-logo {
  background: transparent !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-sidebar-surface {
  border-color: #dce8ea !important;
  background: radial-gradient(circle at 10% 5%, rgba(77, 182, 193, 0.13), transparent 12rem), linear-gradient(180deg, #ffffff 0%, #fbfdfe 55%, #f4f9fa 100%) !important;
  box-shadow: 12px 0 40px rgba(16, 58, 67, 0.04);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-console-stage {
  background: var(--wt-canvas);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-console-header {
  height: 4rem !important;
  border-color: rgba(202, 220, 224, 0.84) !important;
  background: rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.84), 0 10px 30px rgba(17, 62, 71, 0.03);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-console-topnav > a {
  overflow: hidden;
  transition: color 240ms ease, background-color 240ms ease, border-color 240ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-console-topnav > a::after {
  position: absolute;
  right: 1.25rem;
  bottom: -2px;
  left: 1.25rem;
  height: 2px;
  border-radius: 999px 999px 0 0;
  background: linear-gradient(90deg, #0d8a99, #4771bf);
  content: "";
  opacity: 0;
  transform: scaleX(0.45);
  transition: opacity 220ms ease, transform 300ms cubic-bezier(0.22, 1, 0.36, 1);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-console-topnav > a[class*=border-cyan]::after {
  opacity: 1;
  transform: scaleX(1);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-route-stage {
  scroll-behavior: smooth;
  background: radial-gradient(circle at 77% -10%, rgba(91, 180, 192, 0.12), transparent 34rem), linear-gradient(180deg, #f8fbfc 0%, var(--wt-canvas) 100%) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-route-stage > router-outlet + * {
  display: block;
  min-height: 100%;
  animation: ipt-route-enter 460ms cubic-bezier(0.22, 1, 0.36, 1) both;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-sidebar-brand {
  padding-top: 1.25rem;
  padding-bottom: 1.15rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-sidebar-brand img {
  height: 2.45rem;
  filter: drop-shadow(0 8px 14px rgba(30, 112, 123, 0.09));
  transition: transform 300ms cubic-bezier(0.22, 1, 0.36, 1), filter 300ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-sidebar-brand a:hover img {
  filter: drop-shadow(0 10px 18px rgba(30, 112, 123, 0.17));
  transform: translateY(-1px) scale(1.015);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-account-card {
  overflow: hidden;
  border-color: var(--wt-line) !important;
  border-radius: 0.9rem !important;
  background: rgba(255, 255, 255, 0.84) !important;
  box-shadow: 0 8px 24px rgba(17, 62, 71, 0.05);
  transition: border-color 240ms ease, box-shadow 240ms ease, transform 240ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-account-card:hover {
  border-color: var(--wt-line-strong) !important;
  box-shadow: 0 12px 28px rgba(17, 62, 71, 0.08);
  transform: translateY(-1px);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-sidebar-group--market > .wb-sidebar-group-title {
  position: relative;
  margin: 0 0.15rem 0.7rem;
  padding: 0.7rem 0.75rem 0.7rem 1rem;
  overflow: hidden;
  border: 1px solid rgba(8, 145, 178, 0.16);
  border-radius: 0.75rem;
  color: var(--wt-brand) !important;
  background: linear-gradient(135deg, rgba(236, 254, 255, 0.96), rgba(240, 249, 255, 0.72));
  box-shadow: 0 6px 18px rgba(8, 145, 178, 0.06);
  font-size: 0.92rem !important;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.01em;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-sidebar-group--market > .wb-sidebar-group-title::before {
  position: absolute;
  top: 0.55rem;
  bottom: 0.55rem;
  left: 0.45rem;
  width: 0.2rem;
  border-radius: 999px;
  background: var(--wt-brand);
  content: "";
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-sidebar-link {
  position: relative;
  min-height: 2.4rem;
  border-radius: 0.65rem !important;
  will-change: transform;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-sidebar-link:hover {
  transform: translateX(2px);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-sidebar-link[class*=bg-cyan-700] {
  background: linear-gradient(135deg, #08798a 0%, #116e8b 100%) !important;
  box-shadow: 0 8px 18px rgba(7, 111, 132, 0.2);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-sidebar-link[class*=bg-cyan-700]::before {
  position: absolute;
  top: 50%;
  left: -0.5rem;
  width: 3px;
  height: 1.15rem;
  border-radius: 999px;
  background: #64cad0;
  content: "";
  transform: translateY(-50%);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-console-switcher > a {
  border-color: var(--wt-line) !important;
  border-radius: 0.8rem !important;
  background: rgba(255, 255, 255, 0.74) !important;
  transition: border-color 240ms ease, box-shadow 240ms ease, transform 240ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-console-switcher > a:hover {
  border-color: #b5d5da !important;
  box-shadow: 0 10px 24px rgba(17, 62, 71, 0.075);
  transform: translateY(-2px);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-menu-trigger {
  border-color: var(--wt-line) !important;
  background: rgba(255, 255, 255, 0.86);
  transition: color 220ms ease, border-color 220ms ease, background-color 220ms ease, transform 220ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-menu-trigger:hover {
  border-color: #acd2d7 !important;
  color: var(--wt-brand);
  transform: scale(1.03);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page {
  position: relative;
  isolation: isolate;
  min-height: 100%;
  padding: clamp(1rem, 2vw, 1.8rem) !important;
  color: var(--wt-ink);
  background: radial-gradient(circle at 3% 0%, rgba(77, 184, 194, 0.09), transparent 24rem), transparent !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page::before {
  position: absolute;
  z-index: -1;
  top: 0;
  right: 5%;
  width: 19rem;
  height: 13rem;
  border-radius: 999px;
  background: rgba(215, 238, 241, 0.42);
  content: "";
  filter: blur(62px);
  pointer-events: none;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-container,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--listings > *,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--buyers > * {
  width: 100%;
  max-width: 82.5rem !important;
  margin-right: auto;
  margin-left: auto;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--transaction .ipt-container {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 1rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--transaction .ipt-container > * {
  grid-column: 1/-1;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--transaction .ipt-container > .ipt-operation-section--sale {
  grid-column: 1;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--transaction .ipt-container > .ipt-operation-section--purchase {
  grid-column: 2;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(47, 106, 117, 0.72) !important;
  border-radius: 1.15rem !important;
  background: radial-gradient(circle at 88% -25%, rgba(99, 224, 226, 0.24), transparent 23rem), radial-gradient(circle at 18% 130%, rgba(75, 104, 188, 0.24), transparent 24rem), linear-gradient(132deg, #0b2933 0%, #0b4451 58%, #086270 100%) !important;
  box-shadow: 0 20px 48px rgba(10, 52, 62, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero::before {
  position: absolute;
  top: 0;
  left: 2rem;
  width: 5rem;
  height: 3px;
  border-radius: 0 0 999px 999px;
  background: linear-gradient(90deg, #72e1df, #8da6ff);
  content: "";
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero > * {
  position: relative;
  z-index: 1;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero span[class*=rounded] {
  word-break: keep-all;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero > a {
  color: #d9fbfb !important;
  line-height: 1.3;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero > button {
  color: #0a5360 !important;
  background: #f0ffff !important;
  box-shadow: 0 8px 18px rgba(3, 29, 35, 0.16);
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--transaction .ipt-hero,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--qna .ipt-hero {
  min-height: 7.2rem;
  padding: 1.65rem 1.8rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--applications .ipt-hero > div:first-child,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--listings .ipt-hero > div:first-child,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--buyers .ipt-hero > div:first-child {
  min-height: 7.2rem;
  padding: 1.65rem 1.8rem !important;
  background: transparent !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero h1 {
  color: #fff !important;
  font-size: clamp(1.45rem, 2vw, 1.8rem) !important;
  font-weight: 800 !important;
  line-height: 1.2 !important;
  letter-spacing: -0.035em !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-eyebrow,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero p:first-child {
  color: #85e0e2 !important;
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero h1 + p {
  color: rgba(232, 249, 250, 0.74) !important;
  line-height: 1.65 !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero > div:first-child > div:last-child span,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero > span,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero > div:last-child > span {
  flex: 0 0 auto;
  border-color: rgba(201, 242, 243, 0.24) !important;
  background: rgba(255, 255, 255, 0.1) !important;
  color: #efffff !important;
  line-height: 1.25;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-hero {
  display: grid !important;
  grid-template-columns: minmax(0, 1fr) minmax(25rem, 0.82fr);
  align-items: center !important;
  gap: clamp(1.5rem, 3vw, 3.5rem) !important;
  min-height: 11.25rem !important;
  padding: 1.75rem 1.9rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero-copy {
  min-width: 0;
  max-width: 42rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero-kicker-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operator {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  min-height: 1.55rem;
  padding: 0.25rem 0.55rem;
  border: 1px solid rgba(164, 231, 232, 0.22);
  border-radius: 999px;
  color: rgba(235, 253, 253, 0.82);
  background: rgba(255, 255, 255, 0.08);
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero-description {
  max-width: 38rem;
  margin-top: 0.55rem;
  color: rgba(232, 249, 250, 0.74) !important;
  font-size: 0.8rem;
  line-height: 1.65;
  word-break: keep-all;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-kpis {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.55rem;
  min-width: 0;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-kpi {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.18rem 0.5rem;
  min-width: 0;
  padding: 0.72rem 0.78rem;
  border: 1px solid rgba(212, 246, 247, 0.15);
  border-radius: 0.78rem;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
  transition: border-color 220ms ease, background-color 220ms ease, transform 260ms cubic-bezier(0.22, 1, 0.36, 1);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-kpi:hover {
  border-color: rgba(212, 246, 247, 0.28);
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-2px);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-kpi > span {
  overflow: hidden;
  color: rgba(224, 247, 248, 0.68);
  font-size: 0.65rem;
  font-weight: 700;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-kpi > strong {
  grid-row: span 2;
  align-self: center;
  color: #fff;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-kpi > small {
  overflow: hidden;
  color: rgba(224, 247, 248, 0.5);
  font-size: 0.58rem;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-segmented-nav {
  position: relative;
  gap: 0.35rem !important;
  padding: 0.55rem 0.75rem !important;
  border-color: rgba(214, 229, 232, 0.88) !important;
  background: rgba(240, 247, 248, 0.82) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-segmented-nav > a,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-segmented-nav > button {
  min-height: 2.35rem;
  border-radius: 0.7rem !important;
  white-space: nowrap;
  transition: color 220ms ease, background-color 220ms ease, border-color 220ms ease, box-shadow 240ms ease, transform 220ms ease !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-segmented-nav > a:hover,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-segmented-nav > button:hover {
  transform: translateY(-1px);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-segmented-nav > [class*=bg-sky-700] {
  background: linear-gradient(135deg, #08798a, #236f99) !important;
  box-shadow: 0 7px 16px rgba(7, 111, 132, 0.19) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--applications .ipt-segmented-nav > [aria-pressed=true] {
  border-color: transparent !important;
  background: linear-gradient(135deg, #08798a, #236f99) !important;
  color: #fff !important;
  box-shadow: 0 7px 16px rgba(7, 111, 132, 0.18);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-view {
  transform-origin: 50% 0;
  animation: ipt-view-enter 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page .ipt-surface,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page .ipt-view > section,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page .ipt-view > aside,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page section.ipt-view,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page aside.ipt-view {
  border-color: var(--wt-line) !important;
  border-radius: 1rem !important;
  background-color: rgba(255, 255, 255, 0.98) !important;
  box-shadow: 0 10px 30px rgba(17, 57, 66, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.72) !important;
  transition: border-color 250ms ease, box-shadow 250ms ease, transform 250ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-section {
  --ipt-operation-color: #08798a;
  --ipt-operation-soft: #edf9f9;
  --ipt-operation-border: #c7e3e6;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--ipt-operation-border);
  border-radius: 1.1rem;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 14px 36px rgba(17, 57, 66, 0.065), inset 0 1px 0 rgba(255, 255, 255, 0.8);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-section--purchase {
  --ipt-operation-color: #4d5fc4;
  --ipt-operation-soft: #f0f2ff;
  --ipt-operation-border: #d7dcf5;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 5.25rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--ipt-operation-border);
  background: linear-gradient(135deg, var(--ipt-operation-soft), rgba(255, 255, 255, 0.94));
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-heading {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  min-width: 0;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-index {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 2.55rem;
  height: 2.55rem;
  border: 1px solid color-mix(in srgb, var(--ipt-operation-color) 22%, white);
  border-radius: 0.8rem;
  color: var(--ipt-operation-color);
  background: rgba(255, 255, 255, 0.84);
  box-shadow: 0 6px 16px color-mix(in srgb, var(--ipt-operation-color) 10%, transparent);
  font-size: 0.68rem;
  font-weight: 850;
  letter-spacing: 0.08em;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-section .ipt-eyebrow {
  color: var(--ipt-operation-color) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-head h2 {
  margin-top: 0.35rem;
  color: var(--wt-ink);
  font-size: 1.05rem;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.025em;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-summary {
  flex: 0 0 auto;
  color: var(--wt-muted);
  font-size: 0.72rem;
  font-weight: 650;
  line-height: 1.4;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-section .ipt-action-grid {
  grid-template-columns: minmax(0, 1fr) !important;
  grid-template-rows: repeat(2, minmax(0, 1fr));
  flex: 1 1 auto;
  gap: 0.9rem !important;
  padding: 1rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-stat-grid > article {
  position: relative;
  overflow: hidden;
  border-color: var(--wt-line) !important;
  border-radius: 1rem !important;
  box-shadow: 0 10px 30px rgba(17, 57, 66, 0.05) !important;
  animation: ipt-card-enter 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-stat-grid > article::before {
  position: absolute;
  top: 0;
  right: 1rem;
  left: 1rem;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(20, 154, 165, 0.75), rgba(79, 111, 196, 0.58));
  content: "";
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-stat-grid > article:nth-child(2) {
  animation-delay: 55ms;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-stat-grid > article:nth-child(3) {
  animation-delay: 110ms;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-stat-grid > article:nth-child(4) {
  animation-delay: 165ms;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-grid > a {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
  height: 100%;
  padding: 1.25rem !important;
  border: 1px solid var(--ipt-operation-border, var(--wt-line)) !important;
  border-radius: 1rem !important;
  background: linear-gradient(145deg, #fff 0%, #f8fbfc 100%) !important;
  box-shadow: 0 8px 22px rgba(17, 57, 66, 0.045) !important;
  animation: ipt-card-enter 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
  transition: border-color 250ms ease, box-shadow 250ms ease, transform 300ms cubic-bezier(0.22, 1, 0.36, 1) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-grid > a:nth-child(2) {
  animation-delay: 70ms;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-grid > a:hover {
  border-color: color-mix(in srgb, var(--ipt-operation-color, var(--wt-brand)) 34%, white) !important;
  box-shadow: 0 18px 38px rgba(17, 57, 66, 0.1) !important;
  transform: translateY(-4px);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 2.55rem;
  height: 2.55rem;
  border-radius: 0.8rem;
  color: var(--ipt-operation-color, var(--wt-brand));
  background: var(--ipt-operation-soft, var(--wt-soft));
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-count {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  min-height: 1.65rem;
  padding: 0.3rem 0.62rem;
  border: 1px solid var(--ipt-operation-border, var(--wt-line));
  border-radius: 999px;
  color: var(--ipt-operation-color, var(--wt-brand));
  background: var(--ipt-operation-soft, var(--wt-soft));
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-copy {
  min-width: 0;
  margin-top: 1rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-copy h3 {
  color: var(--wt-ink);
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: -0.025em;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-copy p {
  margin-top: 0.35rem;
  color: var(--wt-muted);
  font-size: 0.76rem;
  line-height: 1.7;
  overflow-wrap: break-word;
  word-break: keep-all;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-steps {
  display: grid;
  gap: 0.38rem;
  margin-top: 0.8rem;
  padding: 0.7rem 0.75rem;
  border: 1px solid rgba(212, 229, 232, 0.8);
  border-radius: 0.72rem;
  background: #f5f9fa;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-steps li {
  display: grid;
  grid-template-columns: 1.15rem minmax(0, 1fr);
  gap: 0.42rem;
  align-items: start;
  min-width: 0;
  color: #5d7078;
  font-size: 0.68rem;
  line-height: 1.55;
  word-break: keep-all;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 999px;
  color: var(--ipt-operation-color, var(--wt-brand));
  background: var(--ipt-operation-soft, var(--wt-soft));
  font-size: 0.58rem;
  font-weight: 850;
  line-height: 1;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-link {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 0.4rem;
  margin-top: auto;
  padding-top: 1rem;
  color: var(--ipt-operation-color, var(--wt-brand));
  font-size: 0.72rem;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-link svg {
  width: 1rem;
  height: 1rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-grid > a > span:last-child {
  transition: transform 260ms cubic-bezier(0.22, 1, 0.36, 1);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-action-grid > a:hover > span:last-child {
  transform: translateX(4px);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page article,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page tbody tr,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page .divide-y > button {
  transition: background-color 200ms ease, box-shadow 220ms ease, transform 220ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page tbody tr:hover,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page .divide-y > button:hover {
  background-color: rgba(235, 248, 249, 0.72) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page tbody tr:focus-visible {
  background-color: #edf8f9 !important;
  box-shadow: inset 3px 0 0 var(--wt-brand);
  outline: none;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page table {
  font-size: 0.75rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page thead {
  color: #5f737b !important;
  background: #f4f8f9 !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page th {
  padding-top: 0.78rem !important;
  padding-bottom: 0.78rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.01em;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page td {
  padding-top: 0.82rem !important;
  padding-bottom: 0.82rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page input:not([type=checkbox]):not([type=radio]),
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page select,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page textarea {
  border-color: #d4e2e5 !important;
  border-radius: 0.68rem !important;
  background-color: #fff !important;
  box-shadow: 0 1px 2px rgba(17, 57, 66, 0.025);
  transition: border-color 200ms ease, background-color 200ms ease, box-shadow 220ms ease, transform 220ms ease !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page select {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2308788a' stroke-width='1.8'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m8.25 9.75 3.75 3.75 3.75-3.75'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 0.75rem center !important;
  background-size: 1rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page select:open {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2308788a' stroke-width='1.8'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='m15.75 14.25-3.75-3.75-3.75 3.75'/%3E%3C/svg%3E") !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page input:not([type=checkbox]):not([type=radio]):hover,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page select:hover,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page textarea:hover {
  border-color: #b4d1d6 !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page input:not([type=checkbox]):not([type=radio]):focus,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page select:focus,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page textarea:focus {
  border-color: #2a929f !important;
  box-shadow: 0 0 0 4px var(--wt-focus), 0 8px 20px rgba(8, 112, 128, 0.065) !important;
  outline: none !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page input::placeholder,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page textarea::placeholder {
  color: #98a8ae;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page button,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page a {
  transition: color 220ms ease, background-color 220ms ease, border-color 220ms ease, box-shadow 240ms ease, opacity 220ms ease, transform 220ms ease !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page button:not(:disabled):active,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page a:active {
  transform: translateY(1px) scale(0.99);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page button:focus-visible,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page a:focus-visible,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page input:focus-visible,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page select:focus-visible,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page textarea:focus-visible,
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-sidebar-link:focus-visible,
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-menu-trigger:focus-visible {
  outline: 3px solid rgba(8, 121, 138, 0.2);
  outline-offset: 2px;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page input[type=checkbox] {
  width: 1.05rem;
  height: 1.05rem;
  flex: 0 0 auto;
  border-color: #b8cbd0;
  accent-color: var(--wt-brand);
  cursor: pointer;
  transition: border-color 200ms ease, box-shadow 200ms ease, transform 200ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page input[type=checkbox]:checked {
  transform: scale(1.07);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-choice {
  padding: 0.55rem 0.7rem;
  border: 1px solid var(--wt-line);
  border-radius: 0.7rem;
  background: #f9fbfc;
  cursor: pointer;
  transition: color 220ms ease, border-color 220ms ease, background-color 220ms ease, box-shadow 220ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-choice:has(input:checked) {
  border-color: #acd3d7;
  color: var(--wt-brand-strong) !important;
  background: #edf8f9;
  box-shadow: 0 5px 16px rgba(8, 112, 128, 0.06);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-status-toggle {
  padding: 0.3rem;
  border: 1px solid var(--wt-line);
  border-radius: 0.8rem;
  background: #f5f9fa;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-status-toggle > button {
  border-radius: 0.6rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-collapse {
  transform-origin: 50% 0;
  animation: ipt-collapse-enter 300ms cubic-bezier(0.22, 1, 0.36, 1) both;
}
@media (min-width: 1440px) {
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page .ipt-view > aside:not(.ipt-record-modal),
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--qna .ipt-view > aside:not(.ipt-record-modal) {
    position: sticky;
    top: 1rem;
    align-self: start;
    max-height: calc(100vh - 6rem);
    overflow-y: auto;
    scrollbar-color: #c4d9dc transparent;
    scrollbar-width: thin;
  }
}
@media (max-width: 1100px) {
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--transaction .ipt-container {
    grid-template-columns: minmax(0, 1fr);
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--transaction .ipt-container > .ipt-operation-section--sale,
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--transaction .ipt-container > .ipt-operation-section--purchase {
    grid-column: 1;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-section .ipt-action-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    grid-template-rows: auto;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-hero {
    grid-template-columns: minmax(0, 1fr);
    gap: 1.35rem !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-kpis {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-kpi {
    grid-template-columns: minmax(0, 1fr);
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-kpi > strong {
    grid-row: auto;
    order: 2;
    margin-top: 0.18rem;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-kpi > small {
    display: none;
  }
}
@media (max-width: 767px) {
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page {
    padding: 0.75rem !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--transaction .ipt-hero,
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--qna .ipt-hero,
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--applications .ipt-hero > div:first-child,
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--listings .ipt-hero > div:first-child,
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page--buyers .ipt-hero > div:first-child {
    min-height: auto;
    padding: 1.25rem !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero::before {
    left: 1.25rem;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-hero {
    gap: 1.15rem !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-hero-kicker-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.55rem;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-dashboard-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-head {
    align-items: flex-start;
    flex-direction: column;
    min-height: auto;
    padding: 1rem;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-summary {
    white-space: normal;
    word-break: keep-all;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-operation-section .ipt-action-grid {
    grid-template-columns: minmax(0, 1fr) !important;
    padding: 0.75rem;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-segmented-nav {
    flex-wrap: nowrap !important;
    overflow-x: auto;
    scrollbar-width: none;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-segmented-nav::-webkit-scrollbar {
    display: none;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page .ipt-select {
    width: 100%;
    min-width: 0;
  }
}
@keyframes ipt-route-enter {
  from {
    opacity: 0;
    transform: translate3d(0, 12px, 0) scale(0.995);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1);
  }
}
@keyframes ipt-view-enter {
  from {
    opacity: 0;
    transform: translate3d(0, 9px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes ipt-card-enter {
  from {
    opacity: 0;
    transform: translate3d(0, 8px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes ipt-collapse-enter {
  from {
    opacity: 0;
    transform: translate3d(0, -5px, 0) scaleY(0.97);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scaleY(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  :host ::ng-deep .wb-console-shell[data-console=transaction] *,
  :host ::ng-deep .wb-console-shell[data-console=transaction] *::before,
  :host ::ng-deep .wb-console-shell[data-console=transaction] *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
:host ::ng-deep .wb-console-shell[data-console=transaction] {
  --market-brand: #08798a;
  --market-brand-strong: #056477;
  --market-ink: #17242c;
  --market-muted: #657780;
  --market-line: #dbe6e8;
  --market-line-strong: #bfd4d8;
  --market-soft: #f5f9fa;
  --market-canvas: #f3f7f8;
  --market-radius: 0.9rem;
  --market-content-max: 82.5rem;
  --market-gap: 1rem;
  --market-hero-from: #123b4e;
  --market-hero-via: #075260;
  --market-hero-to: #1d858d;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-route-stage {
  overflow-x: hidden;
  background: var(--market-canvas) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-workspace {
  background: transparent !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-workspace > *,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-workspace .ipt-container {
  width: 100%;
  max-width: var(--market-content-max) !important;
  margin-right: auto;
  margin-left: auto;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header {
  position: relative;
  overflow: hidden;
  display: flex !important;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  min-height: 9.5rem !important;
  padding: 1.65rem 1.85rem !important;
  border: 1px solid rgba(77, 192, 201, 0.45) !important;
  border-radius: 1rem !important;
  color: #fff;
  background: linear-gradient(112deg, var(--market-hero-from) 0%, var(--market-hero-via) 58%, var(--market-hero-to) 100%) !important;
  box-shadow: 0 16px 34px rgba(19, 61, 72, 0.18) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header::before {
  position: absolute;
  top: 0;
  left: 2.4rem;
  width: 7.25rem;
  height: 3px;
  border-radius: 0 0 999px 999px;
  background: linear-gradient(90deg, #58d9da, #8fa7ff);
  content: "";
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header__copy {
  min-width: 0;
  max-width: 56rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header h1 {
  margin-top: 0.35rem !important;
  color: #fff !important;
  font-size: 1.75rem !important;
  font-weight: 800 !important;
  line-height: 1.2;
  letter-spacing: -0.045em !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header__eyebrow {
  color: #83e3e4 !important;
  font-size: 0.69rem !important;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0.16em !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header__description {
  margin-top: 0.7rem !important;
  color: rgba(226, 242, 244, 0.78) !important;
  font-size: 0.82rem;
  line-height: 1.65 !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header__actions {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header__actions > span {
  display: inline-flex;
  align-items: center;
  min-height: 2.15rem;
  padding: 0.45rem 0.75rem;
  border: 1px solid rgba(217, 246, 248, 0.28);
  border-radius: 0.55rem;
  color: #e8f7f8;
  background: rgba(255, 255, 255, 0.1);
  font-size: 0.72rem;
  font-weight: 700;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header__primary {
  min-height: 2.75rem;
  padding: 0.7rem 1.05rem;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 0.65rem;
  color: #07586a;
  background: #effcfd;
  font-size: 0.78rem;
  font-weight: 800;
  box-shadow: 0 6px 18px rgba(4, 44, 54, 0.14);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header__primary:hover:not(:disabled) {
  background: #fff;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-toolbar {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center;
  gap: 0.55rem !important;
  min-width: 0;
  padding: 0.75rem !important;
  background: #fff !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-toolbar > input,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-toolbar > select {
  min-width: 9rem !important;
  flex: 1 1 10rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-toolbar > input[type=search] {
  min-width: min(18rem, 100%) !important;
  flex: 2 1 20rem;
  width: auto !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-toolbar > button {
  flex: 0 0 auto;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-toolbar > span {
  margin-left: auto !important;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-toolbar-actions {
  min-width: 0;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-workspace-grid {
  grid-template-columns: minmax(0, 1fr) !important;
  gap: var(--market-gap) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-layout {
  width: 100%;
  min-width: 0;
  grid-template-columns: minmax(0, 1fr) !important;
  gap: var(--market-gap) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-panel,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-detail-panel {
  min-width: 0;
  border-color: var(--market-line) !important;
  border-radius: var(--market-radius) !important;
  background: #fff !important;
  box-shadow: 0 8px 24px rgba(26, 59, 66, 0.045) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-detail-panel {
  overflow-wrap: anywhere;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-route-stage > router-outlet + *,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-view {
  animation-fill-mode: backwards;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-route-stage > router-outlet + *:has(.ipt-record-modal),
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-view:has(.ipt-record-modal) {
  animation: none !important;
  transform: none !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-page:has(.ipt-record-modal) {
  isolation: auto;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .wb-route-stage:has(.ipt-record-modal) {
  overflow: hidden !important;
  scroll-behavior: auto;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-modal-backdrop {
  position: fixed;
  z-index: 80;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: rgba(10, 29, 36, 0.54);
  backdrop-filter: blur(3px);
  cursor: default;
  animation: ipt-modal-fade-in 140ms ease-out both;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-modal-backdrop:disabled {
  cursor: wait;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-record-modal {
  position: fixed;
  z-index: 90;
  top: 50%;
  left: 50%;
  width: min(68rem, 100vw - 2rem);
  max-width: none;
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  min-height: 0 !important;
  margin: 0;
  overflow: auto !important;
  transform: translate(-50%, -50%);
  border-radius: 1rem !important;
  box-shadow: 0 28px 80px rgba(7, 31, 39, 0.3) !important;
  overscroll-behavior: contain;
  animation: ipt-modal-rise-in 170ms ease-out both;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-modal-chrome {
  position: sticky;
  z-index: 5;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 3rem;
  padding: 0.65rem 0.9rem;
  border-bottom: 1px solid var(--market-line);
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-modal-chrome p {
  color: var(--market-ink);
  font-size: 0.78rem;
  font-weight: 800;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-modal-chrome button {
  min-height: 2rem;
  padding: 0.35rem 0.75rem;
  border: 1px solid #cbd9dc;
  border-radius: 0.5rem;
  color: #40545c;
  background: #fff;
  font-size: 0.7rem;
  font-weight: 700;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-modal-chrome button:hover:not(:disabled) {
  border-color: #8fb5bb;
  color: var(--market-brand-strong);
  background: #f4fafb;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-modal-chrome button:disabled {
  cursor: wait;
  opacity: 0.55;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-content-modal {
  width: min(46rem, 100vw - 2rem);
}
@keyframes ipt-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes ipt-modal-rise-in {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-50% + 0.75rem));
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-toolbar {
  min-height: 4rem;
  border-bottom: 1px solid var(--market-line) !important;
  background: #fff !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-toolbar > input,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-toolbar > select,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-toolbar > button,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-toolbar .ipt-toolbar-actions > button {
  min-height: 2.5rem;
  border: 1px solid var(--market-line) !important;
  border-radius: 0.65rem !important;
  color: var(--market-ink) !important;
  background: #fff !important;
  font-size: 0.78rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-toolbar > input {
  padding-right: 0.9rem !important;
  padding-left: 0.9rem !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-toolbar > input:focus,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-toolbar > select:focus {
  border-color: var(--market-brand) !important;
  outline: 3px solid rgba(8, 121, 138, 0.12);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-toolbar .ipt-toolbar-actions > button {
  min-width: 4.8rem;
  padding-right: 0.9rem !important;
  padding-left: 0.9rem !important;
  font-weight: 700 !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-toolbar .ipt-toolbar-actions > button:hover:not(:disabled) {
  border-color: var(--market-brand) !important;
  color: var(--market-brand-strong) !important;
  background: var(--market-soft) !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 4.5rem;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid var(--market-line);
  background: var(--market-soft);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-summary h2 {
  margin: 0;
  color: var(--market-ink);
  font-size: 0.88rem;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: -0.02em;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-summary p {
  margin: 0.18rem 0 0;
  color: var(--market-muted);
  font-size: 0.68rem;
  line-height: 1.45;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-summary > span {
  flex: 0 0 auto;
  min-width: 3.25rem;
  padding: 0.35rem 0.65rem;
  border: 1px solid var(--market-line);
  border-radius: 999px;
  color: var(--market-brand-strong);
  background: #fff;
  font-size: 0.7rem;
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-tag {
  display: inline-flex;
  min-height: 1.65rem;
  padding: 0.25rem 0.55rem;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-style: solid;
  border-radius: 9999px;
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 1.05;
  letter-spacing: -0.01em;
  white-space: nowrap;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-loading,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-empty {
  display: flex;
  min-height: 10rem;
  padding: 2.5rem 1rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: var(--market-muted);
  font-size: 0.8rem;
  line-height: 1.6;
  text-align: center;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-empty p {
  margin: 0;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-empty p:first-child {
  color: var(--market-ink);
  font-weight: 700;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-empty p + p {
  margin-top: 0.25rem;
  color: var(--market-muted);
  font-size: 0.72rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-loading--skeleton {
  display: block;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-footer {
  display: flex;
  min-height: 3.75rem;
  padding: 0.7rem 1rem;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-top: 1px solid var(--market-line);
  background: #fff;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-footer__meta {
  color: var(--market-muted);
  font-size: 0.72rem;
  line-height: 1.4;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-footer__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-footer__actions button {
  min-width: 4.25rem;
  min-height: 2.25rem;
  padding: 0.45rem 0.85rem;
  border: 1px solid var(--market-line-strong);
  border-radius: 0.5rem;
  color: var(--market-ink);
  background: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  transition: border-color 160ms ease, color 160ms ease, background-color 160ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-footer__actions button:hover:not(:disabled) {
  border-color: var(--market-brand);
  color: var(--market-brand-strong);
  background: var(--market-soft);
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-footer__actions button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list thead {
  background: #f8fbfc !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list th {
  height: 2.9rem;
  color: #61747b !important;
  font-size: 0.7rem !important;
  font-weight: 700 !important;
  vertical-align: middle;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list tbody tr {
  min-height: 4.75rem;
  transition: background-color 160ms ease;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list tbody td {
  padding-top: 0.85rem !important;
  padding-bottom: 0.85rem !important;
  vertical-align: middle;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-wrap {
  overflow: hidden;
  width: 100%;
  min-width: 0;
  container-type: inline-size;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list {
  width: 100%;
  min-width: 0 !important;
  table-layout: fixed;
  border-collapse: collapse;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list th,
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list td {
  min-width: 0 !important;
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal !important;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list p {
  max-width: 100% !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications th:nth-child(1) {
  width: 20%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications th:nth-child(2) {
  width: 24%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications th:nth-child(3) {
  width: 15%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications th:nth-child(4) {
  width: 12%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications th:nth-child(5) {
  width: 9%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications th:nth-child(6) {
  width: 10%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications th:nth-child(7) {
  width: 10%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers th:nth-child(1) {
  width: 15%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers th:nth-child(2) {
  width: 14%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers th:nth-child(3) {
  width: 30%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers th:nth-child(4) {
  width: 12%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers th:nth-child(5) {
  width: 11%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers th:nth-child(6) {
  width: 18%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings th:nth-child(1) {
  width: 12%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings th:nth-child(2) {
  width: 26%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings th:nth-child(3) {
  width: 10%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings th:nth-child(4) {
  width: 19%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings th:nth-child(5) {
  width: 12%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings th:nth-child(6) {
  width: 10%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings th:nth-child(7) {
  width: 11%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna th:nth-child(1) {
  width: 13%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna th:nth-child(2) {
  width: 14%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna th:nth-child(3) {
  width: 13%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna th:nth-child(4) {
  width: 29%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna th:nth-child(5) {
  width: 12%;
}
:host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna th:nth-child(6) {
  width: 19%;
}
@container (max-width: 52rem) {
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list,
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list tbody {
    display: block;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list thead {
    position: absolute;
    overflow: hidden;
    width: 1px;
    height: 1px;
    padding: 0;
    clip: rect(0 0 0 0);
    white-space: nowrap;
    border: 0;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list tbody {
    padding: 0.65rem;
    background: var(--market-soft);
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list tbody tr {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.7rem 1rem;
    padding: 0.85rem;
    border: 1px solid var(--market-line);
    border-radius: 0.75rem;
    background: #fff;
    box-shadow: 0 2px 8px rgba(26, 59, 66, 0.035);
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list tbody tr + tr {
    margin-top: 0.55rem;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list tbody td {
    display: block;
    width: auto !important;
    padding: 0 !important;
    border: 0;
    text-align: left !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list tbody td::before {
    display: block;
    margin-bottom: 0.22rem;
    color: #83939a;
    font-size: 0.62rem;
    font-weight: 700;
    line-height: 1.25;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications td:nth-child(1)::before {
    content: "접수";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications td:nth-child(2)::before {
    content: "권리 정보";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications td:nth-child(3)::before {
    content: "판매자";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications td:nth-child(4)::before {
    content: "희망 가격";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications td:nth-child(5)::before {
    content: "판매방식";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications td:nth-child(6)::before {
    content: "상태";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--applications td:nth-child(7)::before {
    content: "접수일";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers td:nth-child(1)::before {
    content: "문의자";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers td:nth-child(2)::before {
    content: "상담 유형";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers td:nth-child(3)::before {
    content: "제목 / 내용";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers td:nth-child(4)::before {
    content: "담당자";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers td:nth-child(5)::before {
    content: "상태";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers td:nth-child(6)::before {
    content: "접수일";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings td:nth-child(1)::before {
    content: "게시상태";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings td:nth-child(2)::before {
    content: "매물명";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings td:nth-child(3)::before {
    content: "권리구분";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings td:nth-child(4)::before {
    content: "출원 / 등록번호";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings td:nth-child(5)::before {
    content: "희망가";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings td:nth-child(6)::before {
    content: "거래상태";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings td:nth-child(7)::before {
    content: "수정일시";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna td:nth-child(1)::before {
    content: "상담경로";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna td:nth-child(2)::before {
    content: "상담유형";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna td:nth-child(3)::before {
    content: "상담자";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna td:nth-child(4)::before {
    content: "제목";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna td:nth-child(5)::before {
    content: "상태";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna td:nth-child(6)::before {
    content: "접수일시";
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers td:nth-child(3),
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings td:nth-child(2),
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna td:nth-child(4) {
    grid-column: 1/-1;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list tbody tr:has(td[colspan]) {
    display: block;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list td[colspan]::before {
    display: none;
  }
}
@media (min-width: 100rem) {
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-workspace-grid {
    grid-template-columns: minmax(0, 1.45fr) minmax(28rem, 0.8fr) !important;
  }
}
@media (max-width: 47.99rem) {
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header {
    align-items: flex-start !important;
    min-height: 0 !important;
    padding: 1.25rem !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header::before {
    left: 1.25rem;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header h1 {
    font-size: 1.45rem !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-section-header__actions {
    width: 100%;
    justify-content: flex-start;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-toolbar > input,
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-toolbar > select {
    flex-basis: 100%;
    width: 100% !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-toolbar-actions {
    width: 100%;
    margin-left: 0 !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-summary,
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-footer {
    align-items: flex-start;
    flex-direction: column;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-footer__actions,
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-list-footer__actions button {
    width: 100%;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-record-modal,
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-content-modal {
    top: 50%;
    width: calc(100vw - 1rem);
    max-height: calc(100vh - 1rem);
    max-height: calc(100dvh - 1rem);
    border-radius: 0.8rem !important;
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list tbody tr {
    grid-template-columns: minmax(0, 1fr);
  }
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--buyers td:nth-child(3),
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--listings td:nth-child(2),
  :host ::ng-deep .wb-console-shell[data-console=transaction] .ipt-data-list--qna td:nth-child(4) {
    grid-column: auto;
  }
}`],
})
export class LayoutSidebarComponent implements OnInit {
    public mobileNavOpen: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click', ['$event'])
    public clickout(event: MouseEvent) {
        this.closeMobileNav();
        const target = event.target as HTMLElement;
        const link = target?.closest?.('a');
        if (!link || link.origin !== location.origin) return;
        const stage = document.querySelector('.wb-route-stage');
        if (stage) stage.scrollTo({ top: 0, behavior: 'smooth' });
    }

    @HostListener('document:keydown.escape')
    public closeOnEscape() {
        this.closeMobileNav();
    }

    public openMobileNav(event: Event) {
        event.stopPropagation();
        this.mobileNavOpen = true;
    }

    public closeMobileNav() {
        this.mobileNavOpen = false;
    }

    public isManagementConsole() {
        const path = location.pathname;
        return path.indexOf('/transaction') !== 0 && path.indexOf('/ip-market') !== 0;
    }

    public isTransactionConsole() {
        const path = location.pathname;
        return path.indexOf('/transaction') === 0 || path.indexOf('/ip-market') === 0;
    }

    public isTransactionDashboard() {
        if (location.pathname.replace(/\/$/, '') !== '/transaction') return false;
        const section = new URLSearchParams(location.search).get('section') || 'dashboard';
        return !['stats', 'notices', 'procedure', 'business', 'news'].includes(section);
    }

    public isTopActive(section: string) {
        if (location.pathname !== '/management') return false;
        return new URLSearchParams(location.search).get('section') === section;
    }

    public topNavClass(section: string) {
        const base = 'relative inline-flex h-full items-center gap-2 whitespace-nowrap border-b-2 px-5 text-[12px] font-semibold transition-colors';
        if (this.isTopActive(section)) {
            return base + ' border-emerald-600 bg-emerald-50/70 text-emerald-700';
        }
        return base + ' border-transparent text-slate-500 hover:bg-slate-50 hover:text-slate-800';
    }

    public isMarketTopActive(target: string) {
        if (target === 'members') return location.pathname.indexOf('/ip-market/members') === 0;
        if (target === 'statistics') return location.pathname.indexOf('/ip-market/statistics') === 0;
        if (target === 'applications') return location.pathname.indexOf('/ip-market/applications') === 0;
        if (target === 'qna') return location.pathname.indexOf('/ip-market/qna') === 0;
        if (target === 'listings') return location.pathname.indexOf('/ip-market/listings') === 0;
        if (target === 'buyers') return location.pathname.indexOf('/ip-market/buyer-inquiries') === 0;
        return false;
    }

    public marketTopNavClass(target: string) {
        const base = 'relative inline-flex h-full shrink-0 items-center gap-2 whitespace-nowrap border-b-2 px-5 text-[12px] font-semibold transition-colors';
        if (this.isMarketTopActive(target)) {
            return base + ' border-cyan-600 bg-cyan-50/70 text-cyan-700';
        }
        return base + ' border-transparent text-slate-500 hover:bg-slate-50 hover:text-slate-800';
    }
}

export default LayoutSidebarComponent;